module.exports = __webpack_public_path__ + "media/images/icons/caring-17cec681d873ea71bc038da7ae84ec41.png";